import { useEffect, useState } from 'react';

import { Product } from '@/hooks/use-jurisdiction';
import { readDeeplinkReferredProduct } from '@/utils/deeplink-referred-product';

/**
 * Exposes the deeplink-referred product as the default vertical to forward to Keycloak
 * during registration.
 *
 * Reads from AsyncStorage (persisted by AppsFlyer's onDeepLink handler) rather than the
 * in-memory linking store, so the value survives an app kill between the deeplink arriving
 * and the auth screen mounting.
 *
 * @returns the persisted default vertical (or undefined) and whether the read has completed.
 */
export const useDefaultVertical = () => {
    const [defaultVertical, setDefaultVertical] = useState<Product>();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let active = true;
        readDeeplinkReferredProduct().then(product => {
            if (active) {
                setDefaultVertical(product ?? undefined);
                setLoaded(true);
            }
        });
        return () => {
            active = false;
        };
    }, []);

    return { defaultVertical, loaded };
};
